import { RowProps } from 'common/components/Flex/types';
import Flex from 'common/components/Flex/Flex.tsx';

const Row = ({ children, ...rest }: RowProps) => (
  <Flex {...rest} row>
    {children}
  </Flex>
);

export default Row;
